import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel';

const StickyHeader = require('./components/StickyHeader');
const GoToTop = require('./components/GoToTop');
const ToggleSidebar = require('./components/ToggleSidebar');
const BannerSlider = require('./components/BannerSlider');
const DateFieldPlaceholder = require('./components/DateFieldPlaceholder');


// Initialise our components on jQuery.ready…
jQuery(function ($) {
    
    StickyHeader.init();
    ToggleSidebar.init();
    GoToTop.init();
    BannerSlider.init();
    DateFieldPlaceholder.init();

});